
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire747c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire747c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8RBiA", function(module, exports) {
module.exports = import("f8nHf").then(()=>parcelRequire('3D3lu'));

});

parcelRegister("gHYKl", function(module, exports) {
module.exports = import("jLxxR").then(()=>parcelRequire('7it8H'));

});

parcelRegister("boaqP", function(module, exports) {
module.exports = import("hsps6").then(()=>parcelRequire('85yq0'));

});

parcelRegister("iVioz", function(module, exports) {
module.exports = import("84y0s").then(()=>parcelRequire('cQXRI'));

});

parcelRegister("OqqZh", function(module, exports) {
module.exports = import("7BgAh").then(()=>parcelRequire('8gn8A'));

});

parcelRegister("kjLIB", function(module, exports) {
module.exports = import("blPDP").then(()=>parcelRequire('aFws1'));

});

// Main browser entrypoint.
//
// Strategy:
// 1) Load critical UX modules immediately.
// 2) Defer non-critical modules until idle time or until their section is near viewport.
//
// This keeps first-load JS work small while preserving feature behavior.
(()=>{
    'use strict';
    // Adds `in-view` once for elements marked with `.reveal`.
    // CSS handles the transition from hidden -> visible state.
    const revealSections = document.querySelectorAll('.reveal');
    if (!revealSections.length) return;
    // Reveal each section once when it enters the viewport.
    const revealObserver = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            // Mark as visible and stop observing so each element animates only once.
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
    });
    revealSections.forEach((section)=>revealObserver.observe(section));
})();


var $8d855a6e90dc9a09$exports = {};
$8d855a6e90dc9a09$exports = import.meta.resolve("is0Ds");


var $4db78cf2f361c4f2$exports = {};
$4db78cf2f361c4f2$exports = import.meta.resolve("t1Xqc");


(function() {
    // Theme manager for:
    // - user preference persistence in localStorage
    // - toggle accessibility state updates
    // - brand logo source swapping by active theme
    var STORAGE_KEY = 'mozaic-theme';
    var root = document.documentElement;
    var toggle = document.querySelector('[data-theme-toggle]');
    var brandLogo = document.getElementById('brand-logo');
    var media = window.matchMedia('(prefers-color-scheme: dark)');
    // Returns saved user preference, or null when unavailable/invalid.
    function readStoredTheme() {
        try {
            var value = window.localStorage.getItem(STORAGE_KEY);
            return value === 'light' || value === 'dark' ? value : null;
        } catch (error) {
            return null;
        }
    }
    // Persists explicit user choice so it overrides OS preference.
    function writeStoredTheme(theme) {
        try {
            window.localStorage.setItem(STORAGE_KEY, theme);
        } catch (error) {
        // Ignore storage errors in restricted browsing contexts.
        }
    }
    // Effective theme = explicit root data-theme, otherwise OS preference.
    function getEffectiveTheme() {
        if (root.dataset.theme === 'light' || root.dataset.theme === 'dark') return root.dataset.theme;
        return media.matches ? 'dark' : 'light';
    }
    // Keeps aria labels and pressed state in sync with current theme.
    function updateToggleUI() {
        if (!toggle) return;
        var isDark = getEffectiveTheme() === 'dark';
        toggle.setAttribute('aria-pressed', String(isDark));
        toggle.setAttribute('aria-label', isDark ? 'Activate light mode' : 'Activate dark mode');
    }
    // Uses separate logo assets for light and dark backgrounds.
    function updateBrandLogo() {
        if (!brandLogo) return;
        var lightLogo = new URL($8d855a6e90dc9a09$exports).toString();
        var darkLogo = new URL($4db78cf2f361c4f2$exports).toString();
        var theme = getEffectiveTheme();
        var nextSrc = theme === 'dark' ? darkLogo || lightLogo : lightLogo || darkLogo;
        if (nextSrc) brandLogo.src = nextSrc;
    }
    // Apply stored preference at startup before first interaction.
    var storedTheme = readStoredTheme();
    if (storedTheme) root.dataset.theme = storedTheme;
    updateToggleUI();
    updateBrandLogo();
    if (!toggle) return;
    // User-triggered theme toggle.
    toggle.addEventListener('click', function(event) {
        event.preventDefault();
        var nextTheme = getEffectiveTheme() === 'dark' ? 'light' : 'dark';
        root.dataset.theme = nextTheme;
        writeStoredTheme(nextTheme);
        updateToggleUI();
        updateBrandLogo();
    });
    // Respond to OS theme changes only when user has no explicit saved preference.
    function handleSystemThemeChange() {
        // If user has a stored preference, do not override it on OS changes.
        if (readStoredTheme()) return;
        updateToggleUI();
        updateBrandLogo();
    }
    // Browser compatibility for media query change listeners.
    if (typeof media.addEventListener === 'function') media.addEventListener('change', handleSystemThemeChange);
    else if (typeof media.addListener === 'function') media.addListener(handleSystemThemeChange);
})();


const $f5e5effd96d66274$var$supportsIntersectionObserver = 'IntersectionObserver' in window;
// Run a loader during browser idle time (with a timeout fallback) so non-urgent
// code does not compete with first paint.
function $f5e5effd96d66274$var$loadWhenIdle(loader, timeout = 1600) {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(()=>{
            loader();
        }, {
            timeout: timeout
        });
        return;
    }
    window.setTimeout(()=>{
        loader();
    }, 1);
}
// Load a module the first time a section intersects the viewport.
// Useful for feature code that is only needed once the user scrolls near that area.
function $f5e5effd96d66274$var$loadOnFirstIntersection(selector, loader, options = {}) {
    const target = document.querySelector(selector);
    if (!target) // Section is missing on this page variant; skip silently.
    return;
    if (!$f5e5effd96d66274$var$supportsIntersectionObserver) {
        // Older browsers: eagerly load to keep behavior functional.
        loader();
        return;
    }
    let hasLoaded = false;
    const observer = new IntersectionObserver((entries)=>{
        // Fire once when any observed entry is visible.
        const isVisible = entries.some((entry)=>entry.isIntersecting);
        if (!isVisible || hasLoaded) return;
        hasLoaded = true;
        observer.disconnect();
        loader();
    }, {
        rootMargin: options.rootMargin || '0px 0px -12% 0px',
        threshold: options.threshold || 0.01
    });
    observer.observe(target);
}

// Footer year is not critical for initial rendering.
$f5e5effd96d66274$var$loadWhenIdle(()=>(parcelRequire("8RBiA")));

// Feature modules are scoped by section to reduce first-load script work.
$f5e5effd96d66274$var$loadOnFirstIntersection('#services', ()=>(parcelRequire("gHYKl")));

$f5e5effd96d66274$var$loadOnFirstIntersection('#tech-stack', ()=>(parcelRequire("boaqP")));

$f5e5effd96d66274$var$loadOnFirstIntersection('#projects', ()=>(parcelRequire("kjLIB")));


$f5e5effd96d66274$var$loadOnFirstIntersection('#contact', ()=>{
    // Both modules are tied to the contact area, so load together.
    (parcelRequire("iVioz"));
    (parcelRequire("OqqZh"));
}, {
    rootMargin: '0px 0px 18% 0px'
});


//# sourceMappingURL=mozaictech-landing-page.9d72c12e.js.map
